import { type FC } from 'react'

import { Box, Divider, Text } from '@factorialco/deprecated-design-system'

import InformationTooltip from 'modules/core/components/Inputs/InformationTooltip'
import i18n from 'modules/core/lib/i18n'

import type { BreakdownNode } from './types'

interface SummarySectionProps {
  breakdown: Pick<
    BreakdownNode,
    | 'earnedWagesCents'
    | 'netMonthlySalaryCents'
    | 'capPercentage'
    | 'requestCapCents'
    | 'requestedCents'
    | 'availableCents'
  >
  formatMoney: (cents: number | null | undefined) => string
}

export const SummarySection: FC<SummarySectionProps> = ({ breakdown, formatMoney }) => {
  const capTooltip = i18n.t(
    'salary_advance.employee.breakdown_side_panel.summary.monthly_limit_tooltip',
    {
      netSalary: formatMoney(breakdown.netMonthlySalaryCents),
      capPercent: breakdown.capPercentage ?? '-',
    }
  )

  return (
    <Box
      flexDirection="column"
      border={{ all: { style: 'solid', width: 's1', color: 'grey300' } }}
      borderRadius={{ all: 'abs012' }}
    >
      <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center" padding="s16">
        <Box flexDirection="row" alignItems="center" gap="s6">
          <InformationTooltip information={capTooltip} />
          <Text size="200" color="grey700">
            {i18n.t('salary_advance.employee.breakdown_side_panel.summary.monthly_limit')}
          </Text>
        </Box>
        <Text size="200" color="grey1000">
          {formatMoney(breakdown.requestCapCents)}
        </Text>
      </Box>

      <Divider />

      <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center" padding="s16">
        <Text size="200" color="grey700">
          {i18n.t('salary_advance.employee.breakdown_side_panel.summary.accrued_to_date')}
        </Text>
        <Text size="200" color="grey1000">
          {formatMoney(breakdown.earnedWagesCents)}
        </Text>
      </Box>

      <Divider />

      <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center" padding="s16">
        <Text size="200" color="grey700">
          {i18n.t('salary_advance.employee.breakdown_side_panel.summary.total_advanced')}
        </Text>
        <Text size="200" color="grey1000">
          {formatMoney(breakdown.requestedCents)}
        </Text>
      </Box>

      <Divider />

      <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center" padding="s16">
        <Text size="200" weight="semibold" color="grey700">
          {i18n.t('salary_advance.employee.breakdown_side_panel.summary.available')}
        </Text>
        <Text size="200" weight="semibold" color="grey1000">
          {formatMoney(breakdown.availableCents)}
        </Text>
      </Box>
    </Box>
  )
}
